/** Maps a document name (Portuguese) to a category using keyword heuristics. */
export function inferDocumentCategory(name: string): string {
  const n = name.toLowerCase()
  if (/passaporte|biometria|\brg\b|identidade/.test(n)) return "Identidade"
  if (/renda|extrato|bancário|financeiro|contribuinte|\bnif\b|comprovante de renda|comprovante financeiro/.test(n))
    return "Financeiro"
  if (/saúde|médico|exame|seguro de saúde|seguro saúde|health|medical/.test(n)) return "Saúde"
  if (
    /criminal|certidão|anteceden|formulário de visto|contrato de trabalho|freelance|procura|legal/.test(n)
  )
    return "Legal"
  if (/acomodação|alojamento|endereço|aluguel|moradia|hospedagem|comprovante de aloj/.test(n))
    return "Alojamento"
  if (/aceitação|diploma|universidade|educação|escola|course|study|faculdade/.test(n)) return "Educação"
  return "Outros"
}
